import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ISystemMessage} from "./system-message.interface";

@Injectable()
export class SystemMessageService {

  constructor(private http: HttpClient) {
  }

  list(page: number = 1, limit: number = 50): Observable<{ items: ISystemMessage[]; count: number }> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit));
    return this.http.get<ISystemMessage[]>(`${environment.apiEndpoint}/system-message`, {
      params,
      observe: 'response'
    }).pipe(map((res) => ({
      items: (res.body ?? []) as ISystemMessage[],
      count: Number(res.headers.get('X-Total-Count')) || 0
    })));
  }

  create(body: Partial<ISystemMessage>): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/system-message`, body);
  }
}
